import type { Entitlements } from '@tandemone/types'
import { AlertTriangle } from 'lucide-react'

import { NoticeBanner } from './notice-banner'

/* keyed on the period that failed, not just the user: a later failed payment is
 * a new problem and has to surface again. */
export function BillingAlertBanner({
  entitlements,
  userId
}: {
  entitlements: Entitlements
  userId: string | null
}) {
  if (entitlements.status !== 'past_due') return null

  /* the card is what failed and the subscription is still live, so this goes
   * straight to the card rather than the plan picker. */
  return (
    <NoticeBanner
      tone='warning'
      icon={AlertTriangle}
      action={{ label: 'Fix payment', to: '/billing?tab=payment-method' }}
      dismissId={`past-due:${userId ?? 'anon'}:${entitlements.currentPeriodEnd ?? 'none'}`}
    >
      We couldn&rsquo;t collect your last payment. You still have full access
      while we retry, but your plan ends if it stays unpaid.
    </NoticeBanner>
  )
}
